import existy from './existy';

/**
 * Get valur fromm object by path
 * @export
 * @param {Object} source  object
 * @param {String} path    path to props (use `.` as delim)
 * @param {any}    defaultValue return this attr if result is not exists
 * @returns {any} value
 */
export default function get(source, path = '', defaultValue = null) {
   const pathes = path.split('.');

   while (existy(source) && pathes.length) {
      source = source[pathes.shift()];
   }

   return existy(source) ? source : defaultValue;
}
